const $ = require('jquery')


var Comments = {
    loading: false,
    defaultPage: 2,
    codeValidate: null,
    processSaveComment: false,
    init: function () {
        this.loadMores()
        this.renderCaptcha()
        this.validateComment()
        let code = $('#is_captcha').val()
        this.codeValidate = code
    },
    renderCaptcha() {
        //clear the contents of captcha div first

        var charsArray =
            "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
        var lengthOtp = 6;
        var captcha = [];
        for (var i = 0; i < lengthOtp; i++) {
            var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
            if (captcha.indexOf(charsArray[index]) == -1)
                captcha.push(charsArray[index]);
            else i--;
        }
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 100;
        canv.height = 50;
        var ctx = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.strokeText(captcha.join(""), 0, 30);
        let code = captcha.join("");

        try {
            document.getElementById('is_captcha').value = code
            document.getElementById("captcha").appendChild(canv);
        } catch (e) {
            console.log("cannot load captcha")
        }
    },

    is_email(email) {
        email = $.trim(email);
        console.log(email);
        // var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        } else {
            return true;
        }
    },

    validateComment() {
        let _this = this
        $('#submit_comment').click(function (event) {
            event.preventDefault()
            let error = false
            let $elementName = $('#cmt_name')
            let $elementEmail = $('#cmt_email')
            let $elementCaptcha = $('#cmt_captcha')
            let $elementContent = $('#cmt_content')

            let name = $elementName.val()
            let email = $elementEmail.val()
            let captcha = $elementCaptcha.val()
            $elementName.next().remove()
            if (name.length === 0) {
                error = true
                $('<span class="validate-error-empty">Mời bạn điền thông tin</span>').insertAfter($elementName)
            }

            $elementEmail.next().remove()
            if (email.length === 0) {
                error = true
                $('<span class="validate-error-empty">Mời bạn điền thông tin</span>').insertAfter($elementEmail)
            } else {
                if (!_this.is_email(email)) {
                    error = true
                    $('<span class="validate-error-empty">Email không đúng định dạng</span>').insertAfter($elementEmail)
                }
            }

            $elementCaptcha.next().remove()
            if (captcha.length === 0) {
                error = true
                $('<span class="validate-error-empty">Mời bạn điền thông tin</span>').insertAfter($elementCaptcha)
            } else {
                let code = _this.codeValidate
                if (code !== captcha) {
                    error = true
                    $('<span class="validate-error-empty">Mã xác nhận không đúng</span>').insertAfter($elementCaptcha)
                }
            }

            if (error === true) {
                return
            }

            let dataComments = {
                name: name,
                email: email,
                content: $elementContent.val()
            }
            console.log(URL_SAVE_COMMENTS)
            if (typeof URL_SAVE_COMMENTS !== 'undefined' && _this.processSaveComment === false) {
                $.ajax({
                    beforeSend: function (xhr) {
                        // $('.more_loading').removeClass('hide')
                        _this.processSaveComment = true
                    },
                    url: URL_SAVE_COMMENTS,
                    data: { data: dataComments },
                    method: 'POST',
                }).done(function (results) {
                    _this.processSaveComment = false
                    if (typeof results.comments.comment.collection != 'undefined') {
                        alert('Bình luận được gủi thành công và đang chờ duyệt. Chân thành cảm ơn ý kiến của bạn')
                        console.log(results);
                        $(this).closest('#js-bn-content').find('input[type=text], textarea').val('')
                        $('.popup-close').trigger('click')
                        $('#cmt_content').val('')
                        $('#cmt_count').text(500)
                    }
                    return
                })
            }
        })
    },
    loadMores() {
        let _this = this
        $('body').on('click', '.js-load-comments-articles', function (event) {
            event.preventDefault()
            let $this = $(this)
            $this.remove()
            if (typeof URL_LOAD_MORE_BY_COMMENTS !== 'undefined' && _this.loading === false) {
                $.ajax({
                    beforeSend: function (xhr) {
                        $('.more_loading').removeClass('hide')
                        $this.remove()
                        _this.loading = true
                    },
                    url: URL_LOAD_MORE_BY_COMMENTS,
                    data: {
                        page: _this.defaultPage
                    },
                    method: 'GET',
                }).done(function (results) {
                    $('body .more_loading').remove()
                    if (results.html !== undefined) {
                        _this.defaultPage += 1
                        _this.loading = false
                        $('#comment-box-comments').append(results.html)
                    }
                })
            }
        })
    }
}

module.exports = Comments
